import React from 'react';
import { FDAvatar, FDStack } from '@facet-wealth/design';
import {
  ItemSummaries,
} from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/OnboardingAssetsAndLiabilitiesAdd/OnboardingAssetsAndLiabilitiesAddContent/ItemSummaries';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { dataAttrs } from 'Helpers/Testing';
import { noop } from 'lodash';
import PropTypes from 'prop-types';

const InstitutionGroup = ({ onRefresh }) => {
  const { resource } = useMetaLayoutContext();
  const icon = resource.attr('institutionIcon');
  const name = resource.attr('institutionName');
  return (
    <FDStack direction={'column'} spacing={2} {...dataAttrs('institution-group')}>
      <FDStack direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
        <FDStack direction={'row'} alignItems={'center'} spacing={2}>
          {icon
            ? <FDAvatar
              size={'sm'}
              src={icon}
              alt={`${name} icon`}
            /> : null
          }
          <MetaControlField attr={'institutionName'} simpleRootStyle />
        </FDStack>
        <MetaControlField attr={'institutionTotalBalance'} simpleRootStyle />
      </FDStack>
      <ItemSummaries itemSummaryCollection={resource.attr('items')} onRefresh={onRefresh} />
    </FDStack>
  );
};

InstitutionGroup.defaultProps = {
  onRefresh: noop,
};

InstitutionGroup.propTypes = {
  onRefresh: PropTypes.func,
};

export { InstitutionGroup };
